"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dclRegistrar = void 0;
const schemas_1 = require("@dcl/schemas");
const abis_1 = require("../abis");
exports.dclRegistrar = {
    [schemas_1.ChainId.ETHEREUM_GOERLI]: {
        version: '1',
        abi: abis_1.abis.DCLRegistrar,
        address: '0x6b8da2752827cf926215b43bb8e46fd7b9ddac35',
        name: 'DCLRegistrar',
        chainId: schemas_1.ChainId.ETHEREUM_GOERLI
    },
    [schemas_1.ChainId.ETHEREUM_SEPOLIA]: {
        version: '1',
        abi: abis_1.abis.DCLRegistrar,
        address: '0x7518456ae93eb98f3e64571b689c626616bb7f30',
        name: 'DCLRegistrar',
        chainId: schemas_1.ChainId.ETHEREUM_SEPOLIA
    },
    [schemas_1.ChainId.ETHEREUM_MAINNET]: {
        version: '1',
        abi: abis_1.abis.DCLRegistrar,
        address: '0x2a187453064356c898cae034eaed119e1663acb8',
        name: 'DCLRegistrar',
        chainId: schemas_1.ChainId.ETHEREUM_MAINNET
    }
};
//# sourceMappingURL=dclRegistrar.js.map